/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Empty from './Empty/index'
import PreviewImage from './PreviewImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Sections/Section/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Empty'
let imagesComparisonSectionImageIdValueData = fromData.useDataFormat({ viewPath,
context: 'images_comparison_section',
path: 'image_id',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imagesComparisonSectionImageIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PreviewImage'}>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}